import {
  makeAddressArraySync,
  makeAddressSync,
  ProtocolConfig,
} from "@silo/types";
import { satisfies } from "effect/Function";
import { TOKEN_ADDRESS } from "../token-address";
import { MARKET_ADDRESS } from "../market-address";

export const mainnetLlama = satisfies<ProtocolConfig>()({
  firstBridgeSymbol: "crvUSD",
  secondBridgeSymbol: null,
  marketWhitelist: new Set([
    MARKET_ADDRESS.mainnetLlama.CRV,
    MARKET_ADDRESS.mainnetLlama.sUSDe,
  ]),
  pinnedMarkets: [],
  markets: {
    [MARKET_ADDRESS.mainnetLlama.UWU]: {
      depositMode: {
        base: "protectedOnly",
      },
      warningConfig: {
        warningKey: "UWU",
        scope: "singleMarket",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLlama.sUSDe]: {
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetLlama.OHM]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLlama.CBETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLlama.LDO]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLlama.LINK]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLlama.USDC]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetLlama.YFI]: {
      labelAsDeprecated: true,
    },
  },
  nativeRewards: {
    siloIncentivesControllerAddress: makeAddressSync(
      "0x361384A0d755f972E5Eea26e4F4efBAf976B6461"
    ),
    tokenAddress: TOKEN_ADDRESS.ethereum.CRV,
    symbol: "CRV",
    decimals: 18,
    historicalShareTokens: {
      [TOKEN_ADDRESS.ethereum.CRV]: makeAddressArraySync([
        // scrvUSD-CRV
        "0xb27D1729489d04473631f0AFAca3c3A7389ac9F8",
        // scrvUSD-YFI
        "0xe835fb5e74E20f1ae3074084d286580cCA58b739",
        // sLINK
        "0x2509C0025CB9658f2582C43ffA78dba86ba1758e",
        // scrvUSD-LINK
        "0xe6359F82f9054Ed88629e69Ee646d54092705BA6",
        // sUSDe-crvUSD
        "0x9Aed7aC848e6A6e69cD21a099fcd62d6B8e31737",
      ]),
    },
  },
} as const);
